var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.localData)?_c('header-home-five',{attrs:{"data":_vm.localData}}):_vm._e(),_c('section',{staticClass:"appie-hero-area appie-hero-4-area"},[(this.data)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.terms_and_conditions)}}):_vm._e()]),(_vm.localData)?_c('footer-home-one',{attrs:{"data":_vm.localData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }